export default defineNuxtRouteMiddleware(async (to, from) => {
    const accountStore = useAccounts();
    const needAuth = <boolean>to.meta.needAuth ?? false    
    const publicPages = ['/', '/signup', '/signup/referral', '/forgot-password', '/confirm-otp', '/reset-password', '/terms-of-service', '/terms-of-service/', '/privacy-policy', '/privacy-policy/'];
    const adminPages = ['/admin'];
    const isPublicPage = publicPages.includes(to.path);
    const isAdminPage = to.path === '/admin' || to.path.startsWith('/admin/');
    const isGoogleAuth = (to.path === '/googlesso' || to.path.startsWith('/googlesso/') && to.query.at && to.query.at !== '');


    console.log('Auth Middleware:', { to, from, needAuth, isPublicPage, isAdminPage, isGoogleAuth });
    
    const account = accountStore?.token    

    if (isGoogleAuth){
      accountStore.token = to.query.at as string; // <-- Save token
      await accountStore.loginToken();   
      return navigateTo('/dashboard')
    }

    if (account && isPublicPage) {      
      return navigateTo('/dashboard')
    }

    // Only check loginToken once per session
    if(!isPublicPage && !account){
      await accountStore.loginToken()
      return navigateTo('/')
    }

    if(account && isAdminPage && accountStore.account?.superadmin?.toLowerCase() === 'no') {
      return navigateTo('/dashboard') 
    }

    

    // if ( ! Array.isArray(to.meta.perms)) {
    //   to.meta.perms = [];
    // }
    // const permissionRequirements = <string[]>to.meta.perms
    // if(permissionRequirements.length < 1){
    //   return
    // }  
  });